import React from 'react'
import { usePaymentContext } from 'src/components/pages/payment/payment/context/paymentContext'
import { ItemPaymentReservation } from 'src/components/pages/payment/payment/logic/ItemPaymentReservation'
import { ReservationPayment } from 'src/components/pages/payment/payment/logic/ReservationPayment'
export const Payment = () => {
  const { isReservationOption } = usePaymentContext()
  return <>{isReservationOption ? <ReservationPayment /> : <ItemPaymentReservation />}</>
}
